import window from 'global/window';
import {isBrandPortal} from '@netx/core-cms-next/utils/isBrandPortal';
import {type IBrandPortal} from '../schema';

// TODO: if we use the comented out version (preferred) then vi mocks break all over the place
// why?! this took me hours to hunt down and figure out
// I would assume this causes a race for all the various imports of netx models out there (like currentPortal)
// import {currentPortal} from '@netx/core-cms/singletons/currentPortal';
// const getPortal = () => isBrandPortal() && currentPortal;
export const getCurrentPortal = (): IBrandPortal | null =>
	isBrandPortal() && window.Netx.cms?.portal?.id
		? window.Netx.cms.portal.attributes
		: null;
